import type { SHIPPING_CONFIDENCE_EXPERIMENT } from '../constants';

import { isShippingConfidenceAtRisk } from './isShippingConfidenceAtRisk';

import {
  VARIANT_A_IDENTIFIER,
  VARIANT_B_IDENTIFIER,
} from '@/modules/experiments/config';
import { type OpzlyExperimentValue } from '@/modules/experiments/types';
import { ShippingConfidenceLevel } from '@/modules/product/types';

// varianta = friction for MEDIUM + LOW confidence; variantb = LOW only
export function shouldShowSellerFriction(
  level: ShippingConfidenceLevel | undefined,
  // undefined = no decision (not yet resolved, or none served for this
  // request), which must never show friction
  decision:
    OpzlyExperimentValue<typeof SHIPPING_CONFIDENCE_EXPERIMENT> | undefined
): boolean {
  if (decision === VARIANT_A_IDENTIFIER) {
    return isShippingConfidenceAtRisk(level);
  } else if (
    decision === VARIANT_B_IDENTIFIER &&
    level === ShippingConfidenceLevel.LOW
  ) {
    return true;
  }
  return false;
}
